
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Button,
  Tier,
  Size,
  Category,
  Icon,
  Spinner,
  Flex,
  FlexItem,
  FlexJustify,
  Margin,
  Color,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Button`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Button } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Button>Button Text</Button>`} component={Button} mdxType="Playground">
  <Button mdxType="Button">Button Text</Button>
</Playground>
<p>{`You can also have buttons with just the icon, or just the spinner; for this don't pass any children. "No Children" buttons only support default and small size.`}</p>
<Playground __position={1} __code={`<Flex justify={FlexJustify.START}>
  <FlexItem>
    <Margin size={{ right: Size.SMALL }}>
      <Button leading={<Icon name="command" />} tier={Tier.TERTIARY} />
    </Margin>
  </FlexItem>
  <FlexItem>
    <Margin size={{ right: Size.SMALL }}>
      <Button tier={Tier.TERTIARY} leading={<Spinner color={Color.BLUE} size={Size.SMALL} />} />
    </Margin>
  </FlexItem>
  <FlexItem>
    <Margin size={{ right: Size.SMALL }}>
      <Button leading={<Icon name="mail" />} size={Size.SMALL} />
    </Margin>
  </FlexItem>
  <FlexItem>
    <Margin size={{ right: Size.SMALL }}>
      <Button leading={<Icon name="command" />} size={Size.SMALL}>Small with text</Button>
    </Margin>
  </FlexItem>
  <FlexItem>
    <Margin size={{ right: Size.SMALL }}>
      <Button leading={<Icon name="user" />} tier={Tier.SECONDARY} />
    </Margin>
  </FlexItem>
  <FlexItem>
    <Margin size={{ right: Size.SMALL }}>
      <Button leading={<Icon name="command" />} category={Category.BRAND}>Brand with text</Button>
    </Margin>
  </FlexItem>
  <FlexItem>
    <Button trailing={<Spinner size={Size.SMALL} inversed />} color={Color.GREEN}>Text with spinner</Button>
  </FlexItem>
</Flex>`} mdxType="Playground">
  <Flex justify={FlexJustify.START} mdxType="Flex">
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.SMALL
          }} mdxType="Margin">
        <Button leading={<Icon name="command" mdxType="Icon" />} tier={Tier.TERTIARY} mdxType="Button" />
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.SMALL
          }} mdxType="Margin">
        <Button tier={Tier.TERTIARY} leading={<Spinner color={Color.BLUE} size={Size.SMALL} mdxType="Spinner" />} mdxType="Button" />
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.SMALL
          }} mdxType="Margin">
        <Button leading={<Icon name="mail" mdxType="Icon" />} size={Size.SMALL} mdxType="Button" />
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.SMALL
          }} mdxType="Margin">
        <Button leading={<Icon name="command" mdxType="Icon" />} size={Size.SMALL} mdxType="Button">Small with text</Button>
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.SMALL
          }} mdxType="Margin">
        <Button leading={<Icon name="user" mdxType="Icon" />} tier={Tier.SECONDARY} mdxType="Button" />
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.SMALL
          }} mdxType="Margin">
        <Button leading={<Icon name="command" mdxType="Icon" />} category={Category.BRAND} mdxType="Button">Brand with text</Button>
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Button trailing={<Spinner size={Size.SMALL} inversed mdxType="Spinner" />} color={Color.GREEN} mdxType="Button">Text with spinner</Button>
    </FlexItem>
  </Flex>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;